<template>
	<c-dialog ref="dialog" type="confirm" :title="false" :width="width" :close-button="false">
		<div class="c-confirm flex-column flex-center-main">
			<div class="flex-center-cross">
				<i v-if="iconClass" class="tf" :class="[iconClass]"></i>
				<h5 v-html="text"></h5>
			</div>
			<p v-html="message"></p>
		</div>
			
		<template slot="button">
			<c-button @click="buttonHandle('resolve')">{{buttonName}}</c-button>
			<c-button v-if="cancelButton" color="gray" hollow @click="buttonHandle('cancel')">{{cancelButtonName}}</c-button>
		</template>
	</c-dialog>
</template>

<script>
	export default {
		name: 'confirm',

		data() {
			return {
				title: '消息提醒',
				width: 500,
				text: '',
				message: '',
				icon: 'warn',
				buttonName: '确定',
				cancelButtonName: '取消',
				cancelButton: true
			};
		},

		mounted() {
			this.$refs.dialog.open();
		},

		computed: {
			iconClass() {
				return {
					warn: 'tf-confirm-warn',
					message: 'tf-confirm-message'
				}[this.icon];
			}
		},

		methods: {
			buttonHandle(state) {
				this[state] && this[state]();
				this.$refs.dialog.close();
				this.$refs.dialog.destroy();
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.c-confirm {
		min-height: 100px;
		padding: .6rem .3rem 0 .3rem;
		word-break: break-all;
		
		.tf {
			width: .8rem;
			font-size: .5rem;
			
			elder({
				font-size: 30px
			})
		}
		
		h5 {
			line-height: .6rem;
			font-size: .32rem;
			color: #000;
			
			elder({
				line-height: 38px,
				font-size: 24px
			})
		}
		
		p {
			margin-top: .1rem;
			padding-left: .8rem;
			line-height: .44rem;
			font-size: .28rem;
			color: #666;
			
			elder({
				line-height: 30px,
				font-size: 20px
			})
		}
	}
</style>
